<style lang="less" scoped>
  @import "../vars.less";

  @title-height: 36px;

  .modal {
    width: 90%;
    padding-top: @title-height;
    max-height: 60%;
    min-height: 100px;
    overflow: hidden;
  }
  .modal-overlay {
    z-index: 9999;
  }
  .modal-title {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: @title-height;
    line-height: @title-height;
    font-weight: 500;
    background-color: @primary-color;
    color: #fff;
    text-align: center;
    font-size: 14px;
    margin: 0;
    z-index: 2;
  }
  .modal-content {
    position: absolute;
    top: @title-height; right: 0;
    bottom: 0; left: 0;
    overflow: auto;
  }
  .shadow {
    visibility: hidden;
    opacity: 0;
  }
  .loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, .75);
  }
</style>

<template>
  <van-popup v-model="localVisible" :get-container="getContainer"
    round class="modal" overlay-class="modal-overlay">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="shadow">
      <slot />
    </div>
    <div class="modal-content">
      <slot />
      <div class="loading" v-if="loading">
        <van-loading  color="#009999"/>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Loading } from 'vant'

export default {
  name: 'modal',
  components: {
    'van-popup': Popup,
    'van-loading': Loading
  },
  props: {
    title: String,
    visible: Boolean,
    loading: Boolean
  },
  model: {
    event: 'toggle',
    prop: 'visible'
  },
  data () {
    return {
      localVisible: this.visible
    }
  },
  watch: {
    visible (v) {
      this.localVisible = v
    },
    localVisible (v) {
      if (v !== this.visible) this.$emit('toggle', v)
    }
  },
  methods: {
    getContainer () { return document.body }
  }
}
</script>
